import { render, staticRenderFns } from "./LanguageChip.vue?vue&type=template&id=bdd8d8f0&scoped=true"
import script from "./LanguageChip.vue?vue&type=script&lang=js"
export * from "./LanguageChip.vue?vue&type=script&lang=js"
import style0 from "./LanguageChip.vue?vue&type=style&index=0&id=bdd8d8f0&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdd8d8f0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/pikkle/Dev/eM+/muse/admin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bdd8d8f0')) {
      api.createRecord('bdd8d8f0', component.options)
    } else {
      api.reload('bdd8d8f0', component.options)
    }
    module.hot.accept("./LanguageChip.vue?vue&type=template&id=bdd8d8f0&scoped=true", function () {
      api.rerender('bdd8d8f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Common/LanguageChip.vue"
export default component.exports